/*
 * @Auther: 罗耀祖
 * @Date: 2022-05-25 11:08:25
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-05-25 11:16:22
 * @name: app下载地址
 * @Description: app下载地址
 * @FilePath: \preSaleNafterSaleBackstage\src\config\appDownLoadUrl.config.js
 * @Author: desktop
 */
export const dev_ios_distributor = 'https://www.pgyer.com/Oo1G';
export const dev_android_distributor = 'https://www.pgyer.com/Bz0P';
export const prod_ios_distributor = 'https://apps.apple.com/cn/app/%E6%B5%B7%E4%BC%A6%E6%98%93%E8%B4%AD/id1585770232';
export const prod_android_distributor = 'http://cn-beijing-hailun-rc.oss-cn-qingdao.aliyuncs.com/%E5%AE%89%E5%8D%93/agency.apk';

export const dev_ios_inside = 'https://www.pgyer.com/VVbG';
export const dev_android_inside = 'https://www.pgyer.com/sfNn';
export const prod_ios_inside = 'https://apps.apple.com/cn/app/%E6%B5%B7%E4%BC%A6%E4%B8%9A%E5%8A%A1%E5%8A%A9%E6%89%8B/id1585776327';
export const prod_android_inside = 'http://cn-beijing-hailun-rc.oss-cn-qingdao.aliyuncs.com/%E5%AE%89%E5%8D%93/company.apk';